import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M12 3l0 6","key":"svg-1"}],["path",{"d":"M12 15l0 6","key":"svg-2"}]]

const IconGitCommit = createReactComponent('outline', 'git-commit', 'GitCommit', __iconNode);

export default IconGitCommit;